import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import * as Cookies from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => Cookies.get(key),
        setItem: (key, value) => Cookies.set(key, value, { expires: 7, secure: true }),
        removeItem: (key) => Cookies.remove(key),
      },
    }),
  ],
  strict: true,
  //NOTE: Console warning
  //[vuex] state field "route" was overridden by a module with the same name at "route"
  state: {
    token: null,
    isUserLoggedIn: false,
    userId: null,
    userRole: null,
    organizationId: null,
    environmentId: null,
    instanceId: null,
    jobId: null,
    taskId: null,
    currentTaskName: null,
    currentJobName: null,
    envName: null,
    envAdminHost: null,
    envRights: null,
    currentServer: null,
    envType: null,
  },
  mutations: {
    logoutRDM(state) {
      state.token = null
      state.isUserLoggedIn = false
      state.userId = null
      state.userRole = null
      state.organizationId = null
    },
    logoutPA(state) {
      state.instanceId = null
      state.jobId = null
      state.taskId = null
      state.currentServer = null
      state.currentTaskName = null
      state.currentJobName = null
    },
    setCurrentTaskName(state, payload) {
      state.currentTaskName = payload
    },
    setCurrentJobName(state, payload) {
      state.currentJobName = payload
    },
    resetEnvironment(state) {
      state.environmentId = null
      state.envName = null
      state.envAdminHost = null
      state.envRights = null
      state.envType = null
    },

    setUserId(state, userId) {
      state.userId = userId
      state.isUserLoggedIn = true
    },
    setUserRole(state, userRole) {
      state.userRole = userRole
    },
    setOrganizationId(state, organizationId) {
      state.organizationId = organizationId
    },
    setEnvironmentId(state, environmentId) {
      state.environmentId = environmentId
    },
    setInstanceId(state, instanceId) {
      state.instanceId = instanceId
    },
    setJobId(state, jobId) {
      state.jobId = jobId
    },
    setTaskId(state, taskId) {
      state.taskId = taskId
    },
    setEnvName(state, payload) {
      state.envName = payload
    },
    setEnvAdminHost(state, payload) {
      state.envAdminHost = payload
    },
    setEnvRights(state, payload) {
      state.envRights = payload
    },
    setCurrentServer(state, payload) {
      state.currentServer = payload
    },
    setEnvType(state, payload) {
      state.envType = payload
    },
  },
  actions: {
    disconnect({ commit }) {
      commit('disconnect')
    },
    logoutRDM({ commit }) {
      commit('logoutRDM')
    },
    logoutPA({ commit }) {
      commit('logoutPA')
    },
    setCurrentTaskName({ commit }, payload) {
      commit('setCurrentTaskName', payload)
    },
    setCurrentJobName({ commit }, payload) {
      commit('setCurrentJobName', payload)
    },
    resetEnvironment({ commit }) {
      commit('resetEnvironment')
    },
    setUserId({ commit }, userId) {
      commit('setUserId', userId)
    },
    setUserRole({ commit }, userRole) {
      commit('setUserRole', userRole)
    },
    setOrganizationId({ commit }, organizationId) {
      commit('setOrganizationId', organizationId)
    },
    setEnvironmentId({ commit }, environmentId) {
      commit('setEnvironmentId', environmentId)
    },
    setInstanceId({ commit }, instanceId) {
      commit('setInstanceId', instanceId)
    },
    setJobId({ commit }, jobId) {
      commit('setJobId', jobId)
    },
    setTaskId({ commit }, taskId) {
      commit('setTaskId', taskId)
    },
    setEnvName({ commit }, payload) {
      commit('setEnvName', payload)
    },
    setEnvAdminHost({ commit }, payload) {
      commit('setEnvAdminHost', payload)
    },
    setEnvRights({ commit }, payload) {
      commit('setEnvRights', payload)
    },
    setEnvType({ commit }, payload) {
      commit('setEnvType', payload)
    },
    setCurrentServer({ commit }, payload) {
      commit('setCurrentServer', payload)
    },
  },
})
